export default __webpack_public_path__ + "static/media/add-onyx.a3e3aecd.svg";